import React from 'react';
import PropTypes from 'prop-types';

const ICON_SIZE = 24;

function SightIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={ICON_SIZE}
      height={ICON_SIZE}
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fillRule="evenodd"
        d="M19.4 4.8H6.8V3H5v18h1.8v-7.2h12.6l-1.8-4.5 1.8-4.5zM14 9.3c0 .99-.81 1.8-1.8 1.8s-1.8-.81-1.8-1.8.81-1.8 1.8-1.8 1.8.81 1.8 1.8z"
      />
    </svg>
  );
}

SightIcon.propTypes = {
  className: PropTypes.string,
};

SightIcon.ICON_SIZE = ICON_SIZE;

export default SightIcon;
